// extracted by mini-css-extract-plugin
export default {"popup":"popup_popup__Fdrtq","glass":"popup_glass__WsKM9","popup_content":"popup_popup_content__zlMVs"};